export default __webpack_public_path__ + "static/media/pending-icon.a2c22a0c.svg";